<template>
  <div :class="$style['login-header']">
    <a :class="$style.logo" :href="localeBaseUrl">
      <DealerPortalLogo class="mr-12 mt-2" />
    </a>
    <NavigationLanguageSwitch class="mr-6" :class="$style['nav-button']" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'

import { parseDataAttributeJson } from '@/js/helper/data-attribute-helper.js'

import NavigationLanguageSwitch from '@/js/components/Navigation/NavigationLanguageSwitch.vue'
import DealerPortalLogo from '@/js/components/Shared/SvgSelect/SVG/DealerPortalLogo.vue'

export default {
  name: 'MobileMinimalNavigation',
  components: {
    NavigationLanguageSwitch,
    DealerPortalLogo,
  },
  props: {
    element: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ...parseDataAttributeJson(this.element),
    }
  },
  computed: {
    ...mapGetters(STOREMODULES.APP, {
      localeBaseUrl: APP_GETTER.LOCALE_BASE_URL,
    }),
  },
}
</script>

<style lang="scss" module>
:global(body.unauthorized header) {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 999999990;

  background: var(--white);
}

:global(body.unauthorized main) {
  padding-top: 5rem !important;
}

.login-header {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    display: none;
  }
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.nav-button {
  min-height: 1.75rem !important;
}
</style>
